<template>
    <div class="service-tabs service-listing">
        <div class="service-tabs__tabs">
            <div class="custom-tabs">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <b-tabs content-class="mt-3" justified>
                                <b-tab v-for="tab in tabs"
                                       :key="tab.id"
                                       :title="tab.title"
                                       @click="tabChange(tab.id), clearFilter()">
                                </b-tab>
                            </b-tabs>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        <div class="generic-banner">
            <div class="container">
                <div v-if="departments">
                    <div class="accordion-wrapper">
                        <h3 v-if="noDataMsgDep" class="empty-msg">
                            {{ NoResultMessage }}
                        </h3>
                        <div class="accordion" id="accordionExample">
                            <div class="card icon-card"
                                 v-for="(item, index) in idData.Departments"
                                 :key="index">
                                <div class="icon-card__item">
                                    <div class="icon-card__item__info">
                                        <h2>{{ item.Name }}</h2>
                                    </div>
                                    <div class="icon-card__item__readmore">
                                        <a :href="item.LinkToDetails">
                                            <span>{{ Details }} </span>
                                            <img src="../../../Assets/Images/Sectorlist/circle-arrow.svg"
                                                 width="25" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!departments" class="service-listing ">
                    <div class="row">
                        <div class="col-sm-3 col-lg-3 tablet-full-width">
                            <div class="filter-component">
                                <filterservice :apiResponse="info"
                                               :filter="getData"
                                               :CategoriesOfRules="CategoriesOfRules"
                                               @depArr="depArr = $event"
                                               @categoryArr="cateArr = $event"
                                               @sectorArr="sectorArr = $event"
                                               @subArr="subArr = $event"
                                               @healthArr="healthArr = $event"
                                               @funcArr="funcArr = $event"
                                               @tarckApplyFilter="tarckApplyFilter = true"
                                               :PageType="PageType"
                                               :announcement="announcement"
                                               :rules="rules"
                                               :services="services"
                                               @ruleArr="ruleArr = $event"
                                               v-if="info && (services || announcement || rules)"
                                               :sectorLab="SectorLabel"
                                               :categoryLab="CategoryLabel"
                                               :productLab="ProductsLabel"
                                               :functionsLab="FunctionsLabel"
                                               :searchLab="SearchLabel"
                                               @datestart="datestart = $event"
                                               @dateend="dateend = $event"
                                               @resetDate="resetDate = $event"
                                               :ClearDateFilter="ClearDateFilter"
                                               :Apply="Apply"
                                               :Reset="Reset"
                                               :From="From"
                                               :key="reinitFilter"
                                               :To="To"
                                               :Required="Required"
                                               :FilterByDate="FilterByDate"
                                               :BackBtn="BackBtn" />
                                <div class="generic-loader" v-if="apiCallLoader">
                                    <img src="../../../Assets/Images/spinner.svg" />
                                </div>
                            </div>
                           
                        </div>
                        <div class="col-sm-9 col-lg-9 tablet-full-width">
                            <div class="accordion-wrapper">
                                <servicesearch @searchKeyword="(searchWord = $event), (searchClicked = true)"
                                               :searchFilter="getData"
                                               :searchLab="SearchLabel"
                                               :searchPlaceHolder="SearchPlaceHolder"
                                               @tarckApplyFilter="tarckApplyFilter = true" />

                                <div class="accordion"
                                     id="accordionExample"
                                     v-if="announcement">
                                    <h3 v-if="noDataMsgAnnounce" class="empty-msg">
                                        {{ NoResultMessage }}
                                    </h3>
                                    <div v-if="idData.Announcements.length != 0">
                                        <announcementcard :AnnouncementArr="idData.Announcements"></announcementcard>
                                    </div>
                                    
                                </div>

                                <div class="accordion" id="accordionExample" v-if="services">
                                    <h3 class="empty-msg" v-if="noDataMsg">
                                        {{ NoResultMessage }}
                                    </h3>
                                    <div v-if="filteredData.Services.length != 0">
                                        <servicesBlock :serviceCardObj="serviceObj"
                                                       :serviceCardArr="filteredData"
                                                       :mobileView="mobileView"></servicesBlock>
                                    </div>
                                </div>

                                <div class="accordion" id="accordionExample" v-if="rules">
                                    <h3 v-if="noDataMsgRules" class="empty-msg">
                                        {{ NoResultMessage }}
                                    </h3>
                                    <div v-if="idData.RulesAndRegulations.length != 0">
                                        <rulesblock :rulesRegulations="idData.RulesAndRegulations"
                                                    :download="download"></rulesblock>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import servicesearch from "../ServiceSearch/ServiceSearch.vue";
// import filterservice from "../Filter/FilterService.vue";
import filterservice from "../GenericPageComponent/Filter/FilterService.vue";

import announcementcard from "../GenericListingComponent/AnnouncementBlock/AnnouncementCard.vue";
import rulesblock from "../GenericListingComponent/RulesAndRegulationsBlock/RulesAndRegulations.vue";
import servicesBlock from "../GenericListingComponent/ServicesBlock/ServiceCard.vue";

import BTab from 'bootstrap-vue';

Vue.use(BTab, axios);
let baseUrl = document.location.origin;
let apiUrl = baseUrl + "";
let language = window.CurrentLanguage.CurrentLanguage;
export default {
  components: {
    servicesearch,
    filterservice,
    servicesBlock,
    rulesblock,
    announcementcard,
  },
  props: {
    BackBtn: {
      type: String,
    },
    PageType: {
      type: String,
    },
    Apply: {
      type: String,
    },
    Reset: {
      type: String,
    },
    ServiceCost: {
      type: String,
    },
    CentralAdministration: {
      type: String,
    },
    PublicAdministration: {
      type: String,
    },
    Specialization: {
      type: String,
    },
    Cosmetic: {
      type: String,
    },
    SecondaryCategory: {
      type: String,
    },
    Category: {
      type: String,
    },

    SectorDetails: {
      type: Boolean,
    },
    id: {
      type: Number,
    },
    tabs: {
      type: Array,
    },
    Required: {
      type: String,
    },
    Details: {
      type: String,
    },
    download: {
      type: String,
    },
    SearchLabel: {
      type: String,
    },
    searchPlaceHolder: {
      type: String,
    },

    To: {
      type: String,
    },
    From: {
      type: String,
    },
    ClearDateFilter: {
      type: String,
    },
    FilterByDate: {
      type: String,
    },
    CategoriesOfRules: {
      type: String,
    },

    CategoryLabel: {
      type: String,
    },
    SectorLabel: {
      type: String,
    },
    FunctionsLabel: {
      type: String,
    },
    SearchPlaceHolder: {
      type: String,
    },
    ProductsLabel: {
      type: String,
    },
    NoResultMessage: {
      type: String,
    },
  },

  data() {
    return {
      searchClicked: false,
      tarckApplyFilter: false,
      announcement: false,
      rules: false,
      services: false,
      reinitFilter: 0,
      serviceObject: {},
      mobileView: false,
      noDataMsg: false,
      noDataMsgRules: false,
      noDataMsgAnnounce: false,
      tabIndex: 0,
      departments: true,

      tab1: true,
      tab2: false,
      tab3: false,
      pageNumber: 1,
      idData: {
        Departments: [],
        Services: [],
        Announcements: [],
        RulesAndRegulations: [],
        Id: "",
        Title: "",
        Brief: "",
      },
      info: [],
      serviceObj: {},
      filteredData: {
        Services: [],
      },
        noDataMsgDep: false,
        apiCallLoader: false
    };
  },

  methods: {
    tabChange(id) {
      this.departments = false;
      this.services = false;
      this.rules = false;
      this.announcement = false;
      if (id == 0) {
        this.departments = true;
      }
      if (id == 1) {
        this.services = true;
      }
      if (id == 2) {
        this.rules = true;
      }
      if (id == 3) {
        this.announcement = true;
      }
      this.reinitFilter += 1;
    },

    getData() {
      this.noDataMsgRules = false;
      this.noDataMsgAnnounce = false;
      this.noDataMsg = false;

      let categoryChecker = [];
      // if (this.services || this.announcement) {
      //   categoryChecker = this.cateArr;
      // } else {
      //   categoryChecker = this.ruleArr;
      // }

      if (this.rules == true) {
        categoryChecker = this.ruleArr;
      } else {
        categoryChecker = this.cateArr;
      }

        this.idData = {
            Departments: [],
            Services: [],
            Announcements: [],
            RulesAndRegulations: [],
            Id: "",
            Title: "",
            Brief: "",
        };
      if (this.searchClicked || this.tarckApplyFilter) {
        this.pageNumber = 1;
        this.filteredData.Services = [];
      }
        if (this.tarckApplyFilter) {
            if (window.innerWidth > 1025) {
                this.apiCallLoader = true;
            }
        }

      let body = {
            PageType: "sectorDetails",
            SelectedItemId: this.id,
            SubCategories: this.subArr,
            DateFrom: this.datestart,
            DateTo: this.dateend,
            PageNumber: this.pageNumber,
            Categories: categoryChecker,
            Departments: [],
            HealthProducts: this.healthArr,
            Functions: this.funcArr,
            Text: this.searchWord,
            Sectors: this.sectorArr,
      };
      axios
        .post(`${apiUrl}/Umbraco/Surface/Generic/ApplyFilters?culture=${language}`, body)
          .then((response) => {
              this.apiCallLoader = false;
              this.tarckApplyFilter = false;
              this.searchClicked = false;
          this.idData = response.data;

          if (this.idData.Announcements.length == 0) {
            this.noDataMsgAnnounce = true;
          } else {
            this.noDataMsgAnnounce = false;
          }

          if (this.idData.RulesAndRegulations.length == 0) {
            this.noDataMsgRules = true;
          } else {
            this.noDataMsgRules = false;
          }
          if (this.idData.Departments.length == 0) {
            this.noDataMsgDep = true;
          } else {
            this.noDataMsgDep = false;
          }

          //check if services
          if (this.idData.Services.length != 0) {
            if(this.pageNumber == 1) {
              this.filteredData.Services = this.idData.Services;
            } else {
              this.slice();
            }
          } else {
            if (this.filteredData.Services.length != 0) {
              this.noDataMsg = false;
            } else {
              this.noDataMsg = true;
            }
          }
        });
    },
    getInfo() {
      axios
        .post(`${apiUrl}/Umbraco/Surface/Generic/GetAllFilters?culture=${language}`)
        .then((response) => {
          this.info = response.data;
          this.allCategories = this.info.Categories;

          // let UserObj = {};

          for (let item of this.info.Categories) {
            this.$set(item, "checked", false);
            item.SubCategories = item.SubCategories.map((str, index) => ({
              value: str,
              id: index + 1,
              checked: false,
            }));
          }

          for (let item of this.info.Sectors) {
            this.$set(item, "checked", false);
            item.Department = item.Department.map((str, index) => ({
              value: str,
              id: index + 1,
              checked: false,
            }));
          }

          for (let item of this.info.HealthProducts) {
            this.$set(item, "checked", false);
          }

          for (let item of this.info.Functions) {
            this.$set(item, "checked", false);
          }
        });
    },
    clearFilter() {
      if (this.checkCateg == "service") {
        for (let c of this.info.Categories) {
          c.checked = false;
          for (let sub of c.SubCategories) {
            sub.checked = false;
          }
        }
      }
      for (let sec of this.info.Sectors) {
        sec.checked = false;
        for (let dep of sec.Department) {
          dep.checked = false;
        }
      }

      for (let item of this.info.HealthProducts) {
        item.checked = false;
      }
      for (let item of this.info.Functions) {
        item.checked = false;
      }
      for (let item of this.info.CategoriesForRules) {
        item.checked = false;
      }

      this.cateArr = [];
      this.sectorArr = [];
      this.subArr = [];
      this.depArr = [];
      this.funcArr = [];
      this.healthArr = [];
      this.ruleArr = [];
      this.datestart = "";
      this.dateend = "";
      this.searchWord = "";
      this.pageNumber = 1;
      this.filteredData.Services = [];
      this.getData();
    },
    slice() {
      this.filteredData.Services = this.filteredData.Services.concat(
        this.idData.Services
      );
    },
    checkTrigger() {
      const options = {
        threshold: 0.1,
      };
      const checker = document.querySelector(".footer");
      const infiniteScroll = (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (this.idData.Services.length != 0 && this.services) {
                this.isAjaxLoading = true;
                if (window.innerWidth > 1025) {
                    this.apiCallLoader = true;
                }
              setTimeout(() => {
                this.pageNumber++;
                this.getData();
                this.isAjaxLoading = false;
              }, 500);
            }
          }
        });
      };
      const observer = new IntersectionObserver(infiniteScroll, options);
      observer.observe(checker);

    },
  },
  mounted() {
    this.getData();
    this.getInfo();
    document.querySelector(".register-page-form__loader").style.display =
      "none";

    document.querySelector(".register-page-form__loader").style.display =
      "none";
    if (window.innerWidth < 768) {
      this.mobileView = true;
    }

    this.serviceObj = {
      ServiceCost: this.ServiceCost,
      CentralAdministration: this.CentralAdministration,
      PublicAdministration: this.PublicAdministration,
      Specialization: this.Specialization,
      Cosmetic: this.Cosmetic,
      SecondaryCategory: this.SecondaryCategory,
      Category: this.Category,
    };
    setTimeout(()=> {
      this.checkTrigger();
    }, 100)
  },
};
</script>
